import itemquickview from "./item-quickview.html";

const quickviewHandler = require('../../../../../components/quickview/quickview-handler')
const dtHandler = require('../../../../../components/dt/dt-handler')
const chart = require('./chart/item-quickview-chart')
const snack = require('./item-snack')


/****************ELEMENTS*****************/
var htmlQf = {}
var HTMLwasSelected = false

function HTMLselect(detail) {


      quickviewHandler.HTMLselect(

            'item', //database table name****
            'item-quickview',
            detail.ev.target, //source, for example AC
            itemquickview,
            htmlQf)

      HTMLwasSelected = true


}/**/

export function start(detail) {

      if (!HTMLwasSelected) { HTMLselect(detail) }

      obj[detail.act].start(detail)
}/**/

const obj = {

      show: { start: (detail) => { chart.clearQuickviewChart(); quickviewHandler.show(detail, htmlQf) } },
      hide: { start: (detail) => { chart.clearQuickviewChart(); quickviewHandler.hide(detail, htmlQf) } },

      getExtraData: { start: (detail) => { getExtraData(detail, htmlQf) } },
}/**/

async function getExtraData(detail, htmlQf) {

      let idItem = detail.idItem || null;
      // 1. Si no hay ID en detail, buscamos en el DOM
      if (!idItem) {
            const container = detail.ev?.target?.nextElementSibling;
            if (!container) return;

            // Verificamos si el chip tiene elementos (está seleccionado)
            const chip = container.querySelector('.chip-cont');

            if (chip && chip.childElementCount > 0) {
                  const otherFieldElem = container.querySelector(".item_id .otherField") || container.querySelector(".purchase_vs_itemId .otherField");
                  const rawFields = otherFieldElem?.getAttribute('otherField');

                  if (rawFields && rawFields !== "undefined" && rawFields !== "null") {
                        try {
                              const parsed = JSON.parse(rawFields);
                              idItem = parsed.item_id;
                        } catch (error) {
                              console.error("Error al parsear otherField en beeStock:", error);
                        }
                  }
            } else {
                  snack.start({ act: 'show', id: 'error', text: 'Select an item' })
            }
      }

      // 2. Si después de las validaciones no hay ID o el chip estaba vacío
      if (!idItem) {
            // Opcional: mostrar un snackbar si el chip estaba vacío
            console.warn("No hay un item seleccionado en el chip.");
            return;
      }

      // 3. Preparar y enviar la petición
      const formData = new FormData();
      formData.append('idItem', idItem);
      formData.append('from', detail.from || '');

      chart.clearQuickviewChart();

      try {
            const response = await fetch("./server/php/queries/entityFunction/item_behaivor.php", {
                  method: "POST",
                  body: formData,
                  credentials: 'same-origin'
            });

            if (!response.ok) throw new Error(`Error HTTP: ${response.status}`);

            const resultados = await response.json();

            // 4. Actualizar la interfaz de beeStock
            if (resultados.data) {
                  console.log(resultados.data);
                  quickviewHandler.show(detail, htmlQf)
                  llenarCamposQuickView(resultados.data);
                  if (resultados.history) createChart(resultados.history);
                  if (resultados.lastRegister) llenarUltimosMovimientos(resultados.lastRegister);
            }

      } catch (err) {
            console.error("Error en obtenerDatosTablaItemBehaivor:", err);
      }
}

function llenarCamposQuickView(datos) {

      const columns = [
            { key: 'roi', label: 'ROI', format: 'percent', behavior: true, title: 'roi_title' },
            { key: 'speed', label: 'Speed', format: 'star', behavior: true },
            { key: 'friction', label: 'Friction', format: 'star', behavior: true },
            { key: 'profit', label: 'Revenue', format: 'star', behavior: true },
            // { key: 'perishable', label: 'Perishable', format: 'percent', behavior: true },
      ];

      const html = dtHandler.dtSimpleFc(datos, columns);

      const title = htmlQf.quickviewHTML.querySelector('#item-title-quickview');
      title.innerHTML = ""
      title.innerHTML = datos[0].name

      const cont = htmlQf.quickviewHTML.querySelector('#item-quickview-behaivor');
      cont.innerHTML = ""
      cont.innerHTML = html

      return
}

function llenarUltimosMovimientos(datos) {

      const columns = [
            { key: 'last_update', label: 'Month', format: 'date', behavior: false },
            { key: 'inversion', label: 'Inversion', format: 'cash', behavior: false },
            { key: 'speed', label: 'Speed', format: '', behavior: false },
            { key: 'friction', label: 'Friction', format: '', behavior: false },
            { key: 'roi', label: 'ROI', format: 'percent', behavior: false, title: 'roi_title' },
            { key: 'perishable', label: 'Perishable', format: 'percent', behavior: false }
      ];

      const html = dtHandler.dtSimpleFc(datos, columns);

      const cont = htmlQf.quickviewHTML.querySelector('#item-quickview-last-movements');
      cont.innerHTML = ""
      cont.innerHTML = html

      return
}

function createChart(data) {
      chart.createChart(data);
}

